<nav mat-tab-nav-bar style="margin-top: 63px; width: 100%; padding: 0">
    <a
        #gd="routerLinkActive"
        *ngIf="isTabMenuVisible('/gruppen/dashboard')"
        [active]="isDashboardTabActive(gd.isActive)"
        [routerLink]="['/gruppen/dashboard']"
        mat-tab-link
        routerLinkActive
        [disabled]="isTabDisabled('dashboard')"
        >&Uuml;bersicht</a
    >
    <!--<a #gd="routerLinkActive" *ngIf="isTabMenuVisible('/gruppen/schlachtanfragen')" [active]="gd.isActive"
      [routerLink]="['/gruppen/schlachtanfragen']" mat-tab-link routerLinkActive
      [disabled]="isTabDisabled('schlachtanfragen')">Schlachtanfragen</a>-->
    <a
        #ga="routerLinkActive"
        *ngIf="isTabMenuVisible('/gruppen/aktuelle')"
        [active]="isTiergruppenTabActive(ga.isActive)"
        [routerLink]="['/gruppen/aktuelle']"
        mat-tab-link
        routerLinkActive
        [disabled]="isTabDisabled('tiergruppen')"
        >Tiergruppen</a
    >
    <a
        #gh="routerLinkActive"
        *ngIf="isTabMenuVisible('/gruppen/historie')"
        [active]="isHistorieTabActive(gh.isActive)"
        [routerLink]="['/gruppen/historie']"
        mat-tab-link
        routerLinkActive
        [disabled]="isTabDisabled('historie')"
        >Historie Tiergruppen</a
    >
    <!-- Buchungshistorie Tab entfernt -->
    <a
        #gt="routerLinkActive"
        *ngIf="isTabMenuVisible('/gruppen/tierlisten')"
        [active]="isTierlistenTabActive(gt.isActive)"
        [routerLink]="['/gruppen/tierlisten']"
        mat-tab-link
        routerLinkActive
        [disabled]="isTabDisabled('tierlisten')"
    >
        <kiene-tabinfo
            [ladeWennKunde]="true"
            [sendeKundeIdOptional]="true"
            [sendeKundeId]="true"
            icon=""
            urlpfad="tierliste/tabinfo.php"
        ></kiene-tabinfo>
        &nbsp;Tierlisten</a
    >
    <!-- Abhollisten Tab entfernt -->
    <a
        #gg="routerLinkActive"
        *ngIf="isTabMenuVisible('/gruppen/aktuelle')"
        [active]="isGlobaleSucheTabActive(gg.isActive)"
        [routerLink]="['/gruppen/globale-suche']"
        mat-tab-link
        routerLinkActive
        [disabled]="isTabDisabled('globale-suche')"
        >Globale Tiersuche</a
    >
    <ng-container *ngIf="isPhitoAdmin()"
        ><a
            #ghit="routerLinkActive"
            *ngIf="isTabMenuVisible('/gruppen/hitmeldungen')"
            [active]="isHitmeldungenTabActive(ghit.isActive)"
            [routerLink]="['/gruppen/hitmeldungen']"
            mat-tab-link
            routerLinkActive
            >HIT Meldungen</a
        >
    </ng-container>
</nav>
<router-outlet></router-outlet>
